import styled from '@emotion/styled';

const ShowAccount = styled('a')(({ theme }) => ({
  color: theme.colors.gray.medium,
  fontSize: theme.fonts.size.xsmall,
}));

export default ShowAccount;
